import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OnboardingComponent } from './onboarding.component';

const routes: Routes = [{ path: '', component: OnboardingComponent }];

export const OnboardingRoutes: ModuleWithProviders<any> = RouterModule.forChild(routes);
